window.ttx = window.ttx || {};

ttx.cache = {
    get: function (cacheName) {
        return this[cacheName];
    },
    set: function (cacheName, value) {
        this[cacheName] = value;
    },
    setAll: function (cacheObj) {
        if (typeof cacheObj !== 'object') return;
        for (const cacheName in cacheObj) {
            if (Object.prototype.hasOwnProperty.call(cacheObj, cacheName)) {
                this.set(cacheName, cacheObj[cacheName]);
            }
        }
    },
    clear: function (cacheName) {
        if (cacheName) {
            delete this[cacheName];
        } else {
            for (const attr in this)
                if (attr !== 'get' && attr !== 'set' && attr !== 'clear')
                    // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
                    delete this[attr];
        }
    }
}
ttx.cache.metas = { get: ttx.cache.get, set: ttx.cache.set, clear: ttx.cache.clear };

/**
 * 创建子缓存对象（Map 语义），提供 get/set/setAll/clear 方法
 * 与 ttx.cache 顶层 API 行为一致，但数据隔离在独立对象上
 * @returns {{get: Function, set: Function, setAll: Function, clear: Function}}
 */
ttx.cache._createSubCache = function () {
    var store = {};
    return {
        get: function (key) {
            return store[key];
        },
        set: function (key, value) {
            store[key] = value;
        },
        setAll: function (obj) {
            if (typeof obj !== 'object' || !obj) return;
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) {
                    store[key] = obj[key];
                }
            }
        },
        clear: function (key) {
            if (key) {
                delete store[key];
            } else {
                store = {};
            }
        }
    };
};

// 领域基础地址 Map：ttx.cache.baseUrls.get('domainKey') 获取领域前端基础地址
// 由 loadExtend 接口返回的 baseUrls 批量写入（ttx.cache.baseUrls.setAll）
ttx.cache.baseUrls = ttx.cache._createSubCache();

// 接口地址缓存：扩展脚本调用扩展接口前需 ttx.cache.cacheUrls.clear() 清除
ttx.cache.cacheUrls = ttx.cache._createSubCache();

// 模板 ID 缓存：ttx.cache.cacheTplids.clear() 清除
ttx.cache.cacheTplids = ttx.cache._createSubCache();

// 以下子缓存为现有 tx.extend.js / tx.rest.js 引用所需，一并补齐以保证现有逻辑可用
// 领域服务配置：ttx.cache.domains.set(domainKey, serviceDomain)
ttx.cache.domains = ttx.cache._createSubCache();
// 领域应用服务地址：ttx.cache.appServers.get(domainKey)
ttx.cache.appServers = ttx.cache._createSubCache();
// 各领域 version.json 内容：ttx.cache.versionJSON.setAll(result.versionJSON)
ttx.cache.versionJSON = ttx.cache._createSubCache();
